import React from 'react';
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  EmailShareButton,
} from 'react-share';


import Button from '../../../../components/Button';

import '../../styles.css';

const CONTRIBUTE_LINK = "https://www.patreon.com/bePatron?u=22305545";
const SHARE_URL = "https://baloo.org";
const SHARE_TITLE = "Join the Baloo waitlist with me to support sustainability in our community.";
const SHARE_SUBJECT = "Here's a sustainability app I think you'll be into"
const SHARE_BODY = "Baloo connects with communities to build focused sustainability goals and actions for local individuals. Join the waitlist with me to help our community be more sustainable."

const mt_attr = () => {
  if (window._paq) {
    window._paq.push(['trackEvent', 'Contribute', 'link_clicked']);
  }
}

const mt_share_fb = () => {
  if (window._paq) {
    window._paq.push(['trackEvent', 'Share', 'facebook']);
  }
}
const mt_share_twitter = () => {
  if (window._paq) {
    window._paq.push(['trackEvent', 'Share', 'twitter']);
  }
}
const mt_share_linkedin = () => {
  if (window._paq) {
    window._paq.push(['trackEvent', 'Share', 'linkedin']);
  }
}
const mt_share_email = () => {
  if (window._paq) {
    window._paq.push(['trackEvent', 'Share', 'email']);
  }
}


const Component = () => (
  <div className="waitlist_inherit">
    <div className="waitlist_header">
      Thank you!
    </div>
    <div className="waitlist_body">
      You can help us get Baloo to you sooner by contributing through our Patreon
      and sharing with your friends!
    </div>
    <Button link={CONTRIBUTE_LINK} onClick={mt_attr}>
      Contribute
    </Button>
    <div>
      <div className="waitlist_share">
        Share
      </div>
      <div className="waitlist_share_container">
        <FacebookShareButton url={SHARE_URL}
                             quote={SHARE_TITLE}
                             beforeOnClick={mt_share_fb}
                             className="waitlist_shareButton"
        >
          <i class="fab fa-facebook-square fa-2x"
             style={{ marginRight: "12px", cursor: "pointer" }}
          />
        </FacebookShareButton>
        <TwitterShareButton url={SHARE_URL}
                            title={SHARE_TITLE}
                            beforeOnClick={mt_share_twitter}
                            className="waitlist_shareButton"
        >
          <i class="fab fa-twitter-square fa-2x"
             style={{ marginRight: "12px", cursor: "pointer" }}
          />
        </TwitterShareButton>
        <LinkedinShareButton url={SHARE_URL}
                             beforeOnClick={mt_share_linkedin}
                             className="waitlist_shareButton"
        >
          <i class="fab fa-linkedin fa-2x"
             style={{ marginRight: "12px", cursor: "pointer" }}
          />
        </LinkedinShareButton>
        <EmailShareButton url={SHARE_URL}
                          beforeOnClick={mt_share_email}
                          subject={SHARE_SUBJECT}
                          body={SHARE_BODY}
                          className="waitlist_shareButton"
        >
          <i class="fas fa-envelope-square fa-2x"
             style={{ marginRight: "12px", cursor: "pointer" }}
          />
        </EmailShareButton>
      </div>
    </div>
  </div>
);

Component.displayName = "ThankYou";

export default Component;



// WEBPACK FOOTER //
// ./src/forms/JoinWaitlist/components/ThankYou/index.js